/**
 * H2C Backend
 * An ASP.NET Core Web API for managing H2C User 
 *
 * The version of the OpenAPI document: V40:2026_02_04_10_21
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TPutFacilityAndPlannedH2AmountDTO } from './tPutFacilityAndPlannedH2AmountDTO';
import { TPutFacilityAndPlannedCO2AmountDTO } from './tPutFacilityAndPlannedCO2AmountDTO';


export interface TPutFacilityDTO { 
    h2_facility?: TPutFacilityAndPlannedH2AmountDTO;
    co2_facility?: TPutFacilityAndPlannedCO2AmountDTO;
}

